"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _4d_mapper_1 = require("4d-mapper");
const global_1 = require("../../../../../commons/global");
const pin_component_1 = require("../pin.component");
const Cesium = window.Cesium;
class Attribute {
}
exports.Attribute = Attribute;
class DatumViewer extends pin_component_1.PinViewer {
    searchDatumAssetId(assetId, annotation) {
        this.mapService.fourD.V.api('/remote/' + this.mapService.fourD.getApi(global_1.APITypes.Datum360.NAME).id + '/objects/TAGGED_ITEM/id/' + assetId)
            .subscribe(succ => {
            if (succ.error) {
                this.openSnackBarError(succ.error);
            }
            else {
                succ.asset_id = succ.id;
                delete succ.id;
                succ.attrs = Object.keys(succ.attrs).map(a => succ.attrs[a]).filter(a => a.value && a.value != '');
                annotation[global_1.AppConstants.DATAUM_ASSET] = succ;
                annotation.uid = succ.hdl;
                annotation.name = succ.asset_id;
                var coords = annotation.cartographic();
                var href = window.location.href;
                href = href.substring(0, href.indexOf('/search')) + '/search/' + annotation.uid;
                this.mapService.fourD.V.api('/remote/' + this.mapService.fourD.getApi(global_1.APITypes.Datum360.NAME).id + '/write', 'post', {
                    tag: assetId,
                    class: succ['clsname'],
                    asset: succ['facility'],
                    coords: 'lat:' + coords.latitude + ' long:' + coords.longitude + ' height:' + coords.height,
                    href: href
                }).subscribe();
                this.mapService.fourD.V.searchByObject(_4d_mapper_1.Annotation)
                    .equals('project', this.mapService.currentProject.id)
                    .equals('active', true)
                    .equals('name', annotation.name)
                    .notEquals('id', annotation.id)
                    .queryObservable()
                    .subscribe(s => {
                    if (s.items.length > 0) {
                        this.openSnackBarError('MAP.DRAWING_EXIST');
                    }
                    else {
                        annotation.saveObservable().subscribe(succ => {
                            this.openSnackBarSuccess('API.' + global_1.APITypes.Datum360.NAME + '.ASSET_FOUND');
                        });
                    }
                });
            }
        }, err => {
            //this.openSnackBarError("API." +  APITypes.Datum360.NAME + ".ASSET_NOT_FOUND")
            console.log('Enter after searching datum');
        });
    }
}
exports.DatumViewer = DatumViewer;
